import React from "react";
import { connect } from "react-redux";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import ReactTable from "react-table";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Icon from "@material-ui/core/Icon";
import Card from "@material-ui/core/Card";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import CardBody from "../../components/Card/CardBody.jsx";
import Typography from "@material-ui/core/Typography";

import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import green from "@material-ui/core/colors/green";
import Switch from "@material-ui/core/Switch";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
toastr.options = {
  closeButton: true,
};

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{
        padding: 8 * 3,
      }}
    >
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
export class ViewDeclarations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // categoryFormContent: props.location && props.location.state && props.location.state.categoryUnderView ? props.location.state.categoryUnderView : addCategoryForm,
      userData: null,
      familyData: [],
      original: [],
      activeTab: 0,
    };
  }
  componentDidMount = () => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data && data.token) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    let Id = this.props.match.params.id;
    axios
      .get(`${domain}/declaration/getbyid/${Id}`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          let data = res.data.data[0];
          console.log("data", data);
          this.setState({
            familyData: data,
            original: res.data,
          });
        }
      })
      .catch((error) => {});
  };
  handleTab = (activeTab = 0) => {
    this.setState({
      activeTab,
    });
  };

  getFlightDetailsColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    //console.log("flight",this.state.familyData.flight.flight_date);
    let column = [
      {
        Header: "Flight",
        accessor: "name",
      },
      {
        Header: "Flight No",
        accessor: "flight_id",
      },
      {
        Header: "Airport Location",
        accessor: "source",
      },
      {
        Header: "Airport Code",
        accessor: "source_code",
      },
      {
        Header: "Departure Date and Time",
        accessor: "flight_date",
        Cell: (props) => {
          return (
            props.original &&
            moment(props.original.flight_date)
              .add(4, "h")
              .format("DD MMM YYYY, h:mm a")
          );
        },
      },
    ];
    return column;
  };

  getFamilyTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Profile",
        Cell: (props) => {
          console.log("ok", props);
          return (
            <img
              className={props.original.profile_pic ? "profile_pic" : null}
              src={props.original.profile_pic}
            />
          );
        },
      },
      {
        Header: "First",
        accessor: "first_name",
      },
      {
        Header: "Middle",
        accessor: "middle_name",
      },
      {
        Header: "Last",
        accessor: "last_name",
      },
      {
        Header: "Suffix",
        accessor: "suffix",
      },
      {
        Header: "Bermudian",
        width: 110,
        Cell: (props) => {
          return (
            <span>
              {props.original.bermudian ? "Resident" : "non-Resident"}
            </span>
          );
        },
      },
      {
        Header: "Birth Date",
        accessor: "dob",
      },
      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Address",
        className: "wrap_column",
        width: 400,
        Cell: (props) => {
          return (
            <span>
              {props.original.address && props.original.address.length > 0
                ? props.original.address[0].street_address +
                  ", " +
                  props.original.address[0].landmark +
                  ", " +
                  props.original.address[0].country +
                  ", " +
                  props.original.address[0].zip_code
                : " "}
            </span>
          );
        },
      },
    ];
    return column;
  };

  getItemsColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Category",
        accessor: "category",
      },
      {
        Header: "No of Items",
        accessor: "count",
      },
      // {
      //   Header: "Currency",
      //   Cell:()=>{
      //     return <span>{"BMD"}</span>
      //   }
      // },
      {
        Header: "Category Amount",
        accessor: "amount",
        Cell: (props) => {
          return (
            <CurrencyFormat
              value={props.original.amount}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          );
        },
      },
    ];
    return column;
  };

  getItemsCostColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    //console.log("up",this.props);
    let column = [
      {
        Header: "Image",
        Cell: (props) => {
          return (
            <img
              className={props.original.itemImage ? "profile_pic" : null}
              src={props.original.itemImage}
            />
          );
        },
      },
      {
        Header: "Reciept",
        Cell: (props) => {
          return (
            <img
              className={props.original.reciept ? "profile_pic" : null}
              src={props.original.reciept}
            />
          );
        },
      },
      {
        Header: "Store",
        accessor: "store_name",
      },
      {
        Header: "Item",
        accessor: "item_name",
      },
      {
        Header: "Category",
        Cell: (props) => {
          return (
            <span>
              {props.original.category ? props.original.category.name : null}
            </span>
          );
        },
      },
      {
        Header: "Purchase Price",
        Cell: (props) => {
          return (
            <span>
              {props.original.amount_bmd ? (
                <CurrencyFormat
                  value={props.original.amount_bmd}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              ) : (
                ""
              )}
            </span>
          );
        },
      },
      {
        Header: "Date of Purchase",
        accessor: "purchase_date",
        // Cell: props => {
        //   return (
        //     props.original &&
        //     moment(props.original.purchase_date).format("DD MMM YYYY, h:mm a")
        //   );
        // }
      },
    ];
    return column;
  };

  getQuestionColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    //console.log(self);
    let column = [
      {
        Header: "Question",
        width: 850,
        className: "wrap_column",
        Cell: (props) => {
          return (
            <span>
              {props.original.questions[0].name
                ? props.original.questions[0].name
                : ""}
            </span>
          );
        },
      },
      // {
      //   Header:"Question_type",
      //   Cell:(props)=>{
      //     return <span>{props.original.questions[0].que_type ? props.original.questions[0].que_type : ""}</span>
      //   }
      // },
      {
        Header: "Answer",
        accessor: "answer",
      },
    ];
    return column;
  };

  //payment details added
  getPaymentDetailsColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    //console.log(self);
    let column = [
      {
        Header: "Gross Total",
        accessor: "gross_total",
        Cell: (props) => {
          return (
            <CurrencyFormat
              value={props.original.gross_total}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          );
        },
      },
      {
        Header: "Net Total",
        accessor: "net_total",
        Cell: (props) => {
          return (
            <CurrencyFormat
              value={props.original.net_total}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          );
        },
      },

      {
        Header: "No of Residents",
        Cell: () => {
          return (
            <span>
              {this.state &&
              this.state.familyData &&
              this.state.familyData.family_members
                ? this.state.familyData.family_members.length
                : ""}
            </span>
          );
        },
      },
      {
        Header: "Transaction Fee",
        accessor: "transaction_fee",
        Cell: (props) => {
          let value =
            props.original.transaction_fee &&
            props.original.transaction_fee.toString();

          let value2 = value && value.split(".");

          if (value2 && value2.length === 2 && value2[1].length === 1) {
            let final = value + "0";
            console.log("lllllllllll", final);
            return (
              <CurrencyFormat
                value={final}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            );
          } else {
            console.log("ppppppppppppp");
            return (
              <CurrencyFormat
                value={props.original.transaction_fee}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            );
          }
        },
      },
      {
        Header: "Amount Due",
        accessor: "amount_due",
        Cell: (props) => {
          let value =
            props.original.amount_due && props.original.amount_due.toString();

          let value2 = value && value.split(".");

          if (value2 && value2.length === 2 && value2[1].length === 1) {
            let final = value + "0";
            console.log("lllllllllll", final);
            return (
              <CurrencyFormat
                value={final}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            );
          } else {
            console.log("ppppppppppppp");
            return (
              <CurrencyFormat
                value={props.original.amount_due}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            );
          }
        },
      },
      {
        Header: "Status",
        accessor: "payment_status",
      },

      {
        Header: "Payment Type",
        Cell: () => {
          return <span>{this.state.familyData.payment_type}</span>;
        },
      },
    ];
    return column;
  };

  //

  getCustomOfficerColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    //console.log(self);
    let column = [
      {
        Header: "Officer Name",
        accessor: "first_name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
    ];
    return column;
  };

  getFinalStatusColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    //console.log(self);
    let column = [
      {
        Header: "Final Status",
        accessor: "status",
      },
      // {
      //   Header: "Email",
      //   Cell :()=>{
      //     return <span>{this.state.familyData.currency}</span>
      //   }
      // },
    ];
    return column;
  };

  getHolderColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Profile",
        Cell: (props) => {
          return (
            <img
              className={props.original.profile_pic ? "profile_pic" : null}
              src={props.original.profile_pic}
            />
          );
        },
      },
      {
        Header: "Username",
        accessor: "user_name",
      },
      {
        Header: "Prefix",
        accessor: "prefix",
      },
      {
        Header: "First",
        accessor: "first_name",
      },
      {
        Header: "Middle",
        accessor: "middle_name",
      },
      {
        Header: "Last",
        accessor: "last_name",
      },
      {
        Header: "Suffix",
        accessor: "suffix",
      },
      {
        Header: "Bermudian",
        Cell: (props) => {
          return (
            <span>
              {props.original.bermudian ? "Resident" : "non-Resident"}
            </span>
          );
        },
      },
      {
        Header: "D.O.B.",
        accessor: "dob",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
    ];
    return column;
  };

  render() {
    const { classes } = this.props;
    let { userData, original, familyData, activeTab } = this.state;

    const theme = withTheme();
    return (
      <div className="add-category-form">
        <Card className="tabs_event">
          <AppBar position="static" color="default" className="tab-header">
            <Tabs
              className="tabs_main_header_custom"
              value={activeTab}
              onChange={(event, index) => this.handleTab(index)}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#c8102e",
                  color: "#c8102e",
                },
              }}
              variant="fullWidth"
              centered
            >
              <Tab
                className="tab_button"
                label="Declaration Holder"
                style={{
                  width: "120px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Family Members"
                style={{
                  width: "110px",
                  minWidth: "auto",
                }}
              />

              <Tab
                className="tab_button"
                label="Flight Details"
                style={{
                  width: "100px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Cost of goods "
                style={{
                  width: "100px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Declared Items"
                style={{
                  width: "80px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Question And Answer"
                style={{
                  width: "120px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Payment Details"
                style={{
                  width: "120px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Officer Details"
                style={{
                  width: "100px",
                  minWidth: "auto",
                }}
              />
              <Tab
                className="tab_button"
                label="Final Status"
                style={{
                  width: "100px",
                  minWidth: "auto",
                }}
              />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={activeTab}
            onChangeIndex={this.handleTab}
          >
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.user
                              ? [familyData.user]
                              : []
                          }
                          columns={this.getHolderColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Declaration Holder found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.family_members
                              ? familyData.family_members
                              : []
                          }
                          columns={this.getFamilyTableColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Family Members found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.flight
                              ? familyData.flight
                              : []
                          }
                          columns={this.getFlightDetailsColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Flight found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>

            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.item_group
                              ? familyData.item_group
                              : []
                          }
                          columns={this.getItemsColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No bookings found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.items
                              ? familyData.items
                              : []
                          }
                          columns={this.getItemsCostColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No bookings found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.additional_information
                              ? familyData.additional_information
                              : []
                          }
                          columns={this.getQuestionColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Questions found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            {/* payment detail */}
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={familyData ? [familyData] : []}
                          columns={this.getPaymentDetailsColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Payment found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={
                            familyData && familyData.customs
                              ? familyData.customs
                              : []
                          }
                          columns={this.getCustomOfficerColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Officer found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div class="add-category-form">
                <GridContainer>
                  <GridItem xs={12}>
                    <Card>
                      <CardBody>
                        <ReactTable
                          data={original.data ? original.data : []}
                          columns={this.getFinalStatusColumn()}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50]}
                          showPaginationBottom={true}
                          minRows={0}
                          noDataText="No Status found"
                          getTheadThProps={(
                            state,
                            rowInfo,
                            column,
                            instance
                          ) => {
                            return {
                              style: {
                                marginBottom: "13px",
                              },
                            };
                          }}
                        />
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
              </div>
            </TabContainer>
          </SwipeableViews>
        </Card>
      </div>
    );
  }
}

export default ViewDeclarations;
